import React from 'react'
import cx from 'clsx'
import { Link, withPrefix } from 'gatsby'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import '~2023/utils/react-lazy-load-image-component/effects/blur.css'
// Material-UI
import useStyles from './ItemList.style'

const ItemList = ({ dataIndex, item, filterSort, totalItems }) => {
  const rankWithinSort = filterSort
    ? parseInt(totalItems - dataIndex, 10)
    : item.rank

  const classes = useStyles({
    categoryHex: item.categoryHex,
    categoryId: item.categoryId,
  })

  return (
    <Link
      itemProp="url"
      itemScope
      itemType="http://schema.org/BlogPosting"
      state={{
        modal: true,
      }}
      to={item.path}
      style={{ textDecoration: 'none' }}
      className={classes.itemRealLink}
    >
      <span className="anchor-tweak" id={`card-${rankWithinSort}`} />
      <LazyLoadImage
        delayTime={0}
        delayMethod="throttle"
        effect="blur"
        height="2"
        src={withPrefix('/images/spacer.gif')}
        threshold={0}
        useIntersectionObserver={true}
        visibleByDefault={false}
        width="100%"
        wrapperClassName={cx(classes.listImage)}
        style={{ height: '0', width: '0' }}
      />
      <div className={cx(classes.itemLink, classes.gridRow, 'listCategory')}>
        {/* {item.rank && (
          <div className={cx(classes.itemRank, 'item--rank')}>{'   '}</div>
        )} */}
        {item.title && (
          <div className={cx(classes.itemTitle)}>{item.title}</div>
        )}
        {item.categoryId && (
          <div className={cx(classes.itemCategoryRank)}>
            <span className={cx(classes.itemCategoryRankText)}>
              {item.categoryTitle}
            </span>
          </div>
        )}
      </div>
    </Link>
  )
}

export default ItemList
